var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/* eslint-disable camelcase, @typescript-eslint/naming-convention */
import api from '@utils/axios';
import { apiInternalSubcontractorAttachmentUploadsPath, finalizeApiInternalSubcontractorAttachmentUploadsPath } from '@routes';
/**
 * `useDirectUpload`'s transport for subcontractor documentation.
 *
 * Uses the raw `@utils/axios` client, NOT `@utils/api-client` — `api-client`'s case-converter
 * would camelCase this endpoint's response (`signed_id` -> `signedId`) and the hook expects the
 * Frozen contract's wire shapes verbatim, snake_case included.
 *
 * The parent travels in the body on both calls. `target_public_id` is NOT sent: the controller
 * derives it from the parent server-side, so a crafted request cannot attach a document to
 * another inspection.
 */
export function createDirectUploadTransport(parent, documentTypeId, 
/**
 * Which of this parent's subcontractors the document belongs to — the prime's Documents tab
 * uploads into a named section. Same value the legacy modal sends: a child tenant id, or
 * `subcontractor#<id>` for an easy-upload subcontractor that has no tenant of its own. The
 * server resolves it against this parent's own work statuses and 404s if it matches none.
 *
 * The subcontractor side has only one answer and omits it.
 */
uploaderTenantId) {
    const scope = Object.assign({ parent_type: parent.parentType, parent_id: parent.parentId, document_type_id: documentTypeId }, (uploaderTenantId === undefined ? {} : { uploader_tenant_id: uploaderTenantId }));
    return {
        presign: (request, signal) => __awaiter(this, void 0, void 0, function* () {
            const response = yield api.post(apiInternalSubcontractorAttachmentUploadsPath(), Object.assign(Object.assign({}, request), scope), { signal });
            return response.data;
        }),
        // The wire body is rooted at `documents` (the controller's `response_root`); the hook
        // consumes a normalised `attachments`.
        finalize: (request, signal) => __awaiter(this, void 0, void 0, function* () {
            const response = yield api.post(finalizeApiInternalSubcontractorAttachmentUploadsPath(), Object.assign(Object.assign({}, request), scope), { signal });
            return { attachments: response.data.documents };
        })
    };
}
